import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Editor, NoTokenPage } from "./pages";
import { Toolkit, TwaShell } from "@/components";

import { DeepLinkHandler } from "./components/deepLinkHandler";
import AppCloseGuard from "./components/AppCloseGuard";

import { LoadingPage } from "@/pages";

import * as Sentry from "@sentry/react";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<div>home</div>} />
      <Route
        path="/v4/twa"
        element={
          <TwaShell>
            <Toolkit>
              <div className="w-full h-screen relative flex space-x-2 py-4 bg-background">
                <div className="absolute inset-0 z-[9999] bg-background">
                  <NoTokenPage isTwa />
                </div>
              </div>
            </Toolkit>
          </TwaShell>
        }
      />
      <Route
        path="/v4/twa/:token"
        element={
          <TwaShell>
            <Editor isTwa />
          </TwaShell>
        }
      />
      <Route path="/v4/:token" element={<Editor />} />
      <Route path="/v4" element={<NoTokenPage />} />
      <Route path="*" element={<div>404 - Not Found</div>} />
    </Routes>
  );
};

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<LoadingPage />}>
      <BrowserRouter>
        <DeepLinkHandler />
        <AppCloseGuard />
        <AppRouter />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
